import { z } from 'zod';
import { route, defineContract } from '../core/types';

// ============================================================
// Body Schemas
// ============================================================

const subscribeBodySchema = z.object({
	subscription: z.object({}).passthrough(),
});

// ============================================================
// Contract
// ============================================================

/**
 * `POST /send/:username` used to live here: any authenticated user could push an
 * arbitrary notification to any other user, with no role gate and no ownership
 * check. It had no caller in any repo — real pushes go NotificationEngine → the
 * `sendPush` SQS topic → `sendPushMessage.consumer.ts`, in process — so it is
 * deleted rather than gated.
 */
export const pushContract = defineContract('push', {
	/**
	 * SELF scope: a caller registers their OWN browser/device. The username comes
	 * from the token, so hijacking another user's subscription — which
	 * `/subscribe/:username` allowed — is not expressible.
	 */
	subscribeUser: route({
		method: 'POST',
		path: '/subscribe',
		body: subscribeBodySchema,
		response: z.string(),
		operationId: 'subscribeUser',
		tags: ['Push'],
		summary: 'Subscribe the caller to push notifications',
	}),
});
